import { ProtectionType } from "../entities";

function mapProtectionType(
  protectionType?: ProtectionType
): "none" | "password" | "recipientAuthentication" {
  switch (protectionType) {
    case ProtectionType.PASSWORTSCHUTZ:
      return "password";
    case ProtectionType.ANGEMELDETEREMPFÄNGER:
      return "recipientAuthentication";
    default:
      return "none";
  }
}

export { mapProtectionType };
